<template>
  <div class="main">
    <van-nav-bar
      fixed
      title="卡券核销确认页面"
      left-arrow
      @click-left="onClickLeft"
    />
    <template v-if="detail">
      <div class="ticketBox">
        <div class="topBox">
          <p>{{ detail.couponName }}</p>
          <p v-if="detail.couponType == 1 || detail.couponType == 4">
            (满{{ detail.transactionMinimumAmount }}元减{{
              detail.discountAmount
            }}元)
          </p>
          <p v-if="detail.couponType == 2">
            (满{{ detail.transactionMinimumAmount }}元打{{
              detail.discountPercent / 10
            }}折)
          </p>
          <p v-if="detail.couponType == 3">
            (满{{ detail.transactionMinimumAmount }}元可用)
          </p>
          <p v-if="detail.couponType == 5">
            (满{{ detail.transactionMinimumAmount }}元可用)
          </p>
        </div>
        <div class="botBox">
          <p>发券活动名称：{{ detail.stockName }}</p>
          <p>券码：{{ detail.couponNum }}</p>
        </div>
      </div>

      <div
        class="detailBox"
        v-if="detail.validityStartTime && detail.validityEndTime"
      >
        <span class="title">有效日期：</span>
        <span class="detailCon"
          >{{ detail.validityStartTime.split(" ")[0] }} 至
          {{ detail.validityEndTime.split(" ")[0] }}</span
        >
      </div>

      <div class="detailBox">
        <span class="title">可用时段：</span>
        <span class="detailCon">{{ detail.availableTimePeriod }}</span>
      </div>

      <div class="detailBox">
        <span class="title">使用规则：</span>
        <span class="detailCon">{{ detail.useRule }}</span>
      </div>

      <div class="btnBox">
        <van-button
          :disabled="detail.couponStatus != 1"
          :loading="submitLoading"
          class="submitBtn"
          block
          type="info"
          loading-text="请稍后..."
          @click="handleSubmit"
          >{{
            detail.couponStatus == 1
              ? "确认核销"
              : detail.couponStatus == 2
              ? "已使用"
              : detail.couponStatus == 3
              ? "已作废"
              : detail.couponStatus == 4
              ? "已作废"
              : "不可使用"
          }}</van-button
        >
      </div>
    </template>

    <div v-if="isQueried && !detail" class="errorBox">
      <van-empty description="暂无信息" />
    </div>
  </div>
</template>
<script>
import { Field, Notify, NavBar, Dialog, Empty } from "vant";
import globalStyle from "@/utils/style";
import { verifyTicket, ticketDetial } from "@/api/index";
export default {
  components: {
    vanField: Field,
    vanNavBar: NavBar,
    vanEmpty: Empty,
  },
  data() {
    return {
      submitLoading: false,
      couponNum: "",
      type: 1, //1扫码2券码
      detail: "",
      isQueried: false,
    };
  },

  created() {
    this.couponNum = this.$route.query.couponNum || "";
    this.type = this.$route.query.type || 1;
    this.queryTicketDetail();
  },

  methods: {
    // 查询券详情
    queryTicketDetail() {
      return new Promise((resolve, reject) => {
        ticketDetial({ couponNum: this.couponNum })
          .then((res) => {
            this.detail = res.data;
            this.isQueried = true;
            resolve();
          })
          .catch((err) => {
            this.isQueried = true;
            reject();
          });
      });
    },

    //   确认核销
    handleSubmit() {
      this.submitLoading = true;
      verifyTicket({ couponNum: this.couponNum })
        .then(async (res) => {
          await this.queryTicketDetail();
          this.submitLoading = false;
          if (res.data.code == 0) {
            Dialog.confirm({
              message: "核销成功！",
              showCancelButton: true,
              confirmButtonText: "返回首页",
              cancelButtonText: "继续核销",
              confirmButtonColor: globalStyle.themeColor,
              cancelButtonColor: globalStyle.grayColor,
            })
              .then(() => {
                this.$router.push({ path: "/" });
              })
              .catch(() => {
                this.$router.go(-1);
              });
          } else {
            this.$router.push({
              path: "/verifyResult",
              query: { type: this.type, msg: res.data.msg },
            });
          }
        })
        .catch((err) => {
          this.submitLoading = false;
        });
    },

    // 点击返回
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../css.scss";
.main ::v-deep .van-nav-bar .van-icon {
  color: $--font-color;
}
.main {
  width: 375px;
  height: 100%;
  overflow: scroll;
  background-color: $--bg-color;
  border: 0.01px solid rgba(0, 0, 0, 0);
  padding-bottom: 90px;
  box-sizing: border-box;
  .errorBox {
    width: 100%;
    height: calc(100vh - 45px);
    margin-top: 45px;
  }
  .btnBox {
    width: 100%;
    background-color: $--bg-color;
    position: fixed;
    bottom: 0;
    left: 0;
    .submitBtn {
      width: 345px;
      margin: 10px 15px 30px;
      background-color: $--theme-color;
      border-color: $--theme-color;
    }
  }

  .detailBox {
    width: 345px;
    margin: 20px auto 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    span:first-child {
      width: 80px;
      font-size: 14px;
      color: $--gray-color;
    }
    span:last-child {
      width: 265px;
      font-size: 14px;
      // color: $--font-color;
      color: $--gray-color;
      text-align: left;
    }
    .detailCon {
      white-space: pre-wrap;
      line-height: 25px;
    }
  }
  .ticketBox {
    width: 345px;
    border-radius: 10px;
    background-color: #fff;
    padding: 15px;
    margin: 60px 15px 15px;
    .botBox {
      width: 100%;
      height: 60px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      p {
        width: 100%;
        font-size: 14px;
        color: $--font-color;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p:first-child {
        margin-bottom: 8px;
      }
    }
    .topBox {
      width: 100%;
      height: 60px;
      border-bottom: 1px solid $--bg-color;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      p:first-child {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 16px;
        color: $--font-color;
      }
      p:last-child {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        color: $--gray-color;
        margin-top: 8px;
      }
    }
  }
}
</style>
